import { render, staticRenderFns } from "./DiagnosisCard.vue?vue&type=template&id=3a9af815&"
import script from "./DiagnosisCard.vue?vue&type=script&lang=js&"
export * from "./DiagnosisCard.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports